import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Alert01Icon, Copy01Icon, Mail01Icon, Home01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';
import Button from './Button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleCopyError = () => {
    const text = `Error: ${this.state.error?.toString()}\n\nStack:\n${this.state.errorInfo?.componentStack}`;
    navigator.clipboard.writeText(text);
    alert('Error details copied to clipboard');
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-off-white dark:bg-dark-bg flex flex-col items-center justify-center p-6 text-center">
          <div className="bg-white dark:bg-dark-surface p-10 rounded-[3rem] shadow-float-lg max-w-2xl w-full border border-light-gray/20 dark:border-dark-border/20">
            <div className="bg-red-50 dark:bg-red-900/20 p-6 rounded-full inline-block mb-6 animate-pulse">
              <HugeiconsIcon icon={Alert01Icon} size={48} className="text-red-500" />
            </div>
            
            <h1 className="text-3xl font-black text-charcoal dark:text-white mb-2 tracking-tight">Something went wrong</h1>
            <p className="text-muted-gray mb-8">We encountered an unexpected error. Please try reloading or contact support.</p>

            <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-4 mb-8 text-left border border-gray-200 dark:border-gray-800 relative group">
              <pre className="text-[10px] sm:text-xs font-mono text-red-600 dark:text-red-400 overflow-x-auto whitespace-pre-wrap break-all max-h-40 custom-scrollbar">
                {this.state.error?.toString()}
              </pre>
              <button 
                onClick={this.handleCopyError}
                className="absolute top-2 right-2 p-2 bg-white dark:bg-gray-800 rounded-lg shadow-sm opacity-0 group-hover:opacity-100 transition-opacity text-muted-gray hover:text-soft-green"
                title="Copy Error"
              >
                <HugeiconsIcon icon={Copy01Icon} size={16} />
              </button>
            </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <Button onClick={() => window.location.href = '/'} variant="secondary" className="py-4 rounded-2xl font-black gap-2 justify-center">
                            <HugeiconsIcon icon={Home01Icon} size={18} />
                            Go to Dashboard
                          </Button>
                          <Button onClick={this.handleReload} variant="secondary" className="py-4 rounded-2xl font-black gap-2 justify-center">
                            <HugeiconsIcon icon={ArrowRight01Icon} size={18} className="rotate-180" />
                            Reload Page
                          </Button>
                          <Button 
                            onClick={() => window.location.href = `mailto:support@safzi.com?subject=App Crash Report&body=Error Details:%0D%0A${encodeURIComponent(this.state.error?.toString())}`} 
                            className="sm:col-span-2 py-4 rounded-2xl font-black gap-2 justify-center shadow-lg"
                          >
                            <HugeiconsIcon icon={Mail01Icon} size={18} />
                            Contact Support
                          </Button>
                        </div>          </div>
          <p className="mt-8 text-xs font-bold text-muted-gray uppercase tracking-widest">Safzi Error Boundary</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
